var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 7.25a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0M7.25 1a6.25 6.25 0 1 0 3.656 11.32l2.387 2.387a1 1 0 0 0 1.414-1.414l-2.387-2.387A6.25 6.25 0 0 0 7.25 1",
  clipRule: "evenodd"
})));
export default SvgSearchSmall;